import React, { Component } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
    TextField,
    Select,
    MenuItem,
    FormControl,
    FormGroup,
    FormLabel,
    Slide,
    Autocomplete,
    List,
    ListItem,
    ListItemText,
    IconButton
} from '@mui/material';
import Chip from '@mui/material/Chip';
import Checkbox from '@mui/material/Checkbox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { TransitionProps } from "@mui/material/transitions";
import { DateRange, Delete } from '@mui/icons-material';
import { Actions, Texts } from '../../../Component/Reusables/Utility';
import moment from 'moment';
import { IFXPoolDetails } from '../../FXReports/Interface';
import FxAllocationService from '../../../Services/FxAllocationService';
import { ShowAlert } from '../../../Component/ShowAlert';
import { loadFromLocalStorage } from '../../../Common/Validation/LocalStorage';
import InputTextField from '../../../Component/Reusables/InputTextField';
import './FxPurchaseDetail.css';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { fetchRecipientCountryList, fetchSenderCountryList } from '../../../Component/Reusables/Recipient';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement<any, any>;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});
type IDropdownOptionArray = IDropdownOption[] | [];
interface PurchaseDetailsProps {
    open: boolean;
    onClose: () => void;
    refreshData: () => void;
    purchaseData?: IFXPoolDetails;
    action?: Actions;
}

interface FileData {
    isNew: boolean;
    fileAttachmentId: any;
    fileName: string;
    fileType: string;
    fileSize: number;
    fileURL: any;
    base64: string;
}
interface IDropdownOption {
    id: string;
    name: string;
}
interface PurchaseDetailsState {
    isEditing: boolean;
    purchaseData: any;
    actionButtonLabel?: Actions;
    accessToken: string;
    tradeDate: Date;
    settlementDate: Date;
    selectedLiquidityPartner: IDropdownOption | null;
    selectedPayoutPartners: IDropdownOptionArray;
    liquidityPartners: IDropdownOption[];
    payoutPartners: IDropdownOption[];
    statusOptions: IDropdownOption[];
    loading: boolean;
    errors: IErrors | null;
    fromCurrencySymbol: string;
    fromCountryId: string;
    toCurrencySymbol: string;
    toCountryId: string;
    files: FileData[];
    deleteList: any[];
    poolId: string;
}
interface IErrors {
    liquidityPartner: string;
    tradeDate: string;
    baseRate: string;
    sourceRate: string;
    targetRate: string;
    sourceCurrency: string;
    sourceAmount: string;
    targetCurrency: string;
    targetAmount: string;
    attachment: string;
}
const getValidSelectValue = (value: string, options: string[]) => {
    return options.includes(value) ? value : '';
};

class PurchaseDetails extends Component<PurchaseDetailsProps, PurchaseDetailsState> {
    fromCurrencies: any = [];
    toCurrencies: any = [];

    getFromCurrencySymbol = (currencyCode: string) => {
        const currency = this.fromCurrencies.find((c: { currencyCode: string; }) => c.currencyCode === currencyCode);
        return { currencySymbol : currency ? currency.currencySymbol : '$', countryId : currency ? currency.countryId : ''};
    };
    getToCurrencySymbol = (currencyCode: string) => {
        const currency = this.toCurrencies.find((c: { currencyCode: string; }) => c.currencyCode === currencyCode);
        return { currencySymbol : currency ? currency.currencySymbol : '$', countryId : currency ? currency.countryId : ''};
    };
    initialState: any;

    constructor(props: PurchaseDetailsProps) {
        super(props);
        this.initialState = {
            isEditing: props.action === Actions.Edit || props.action === Actions.Create,
            purchaseData: {
                ...props.purchaseData,
                currencySpent: props.purchaseData?.currencySpent || 'USD',
                currencyObtained: props.purchaseData?.currencyObtained || 'GHS',
                amountSpent: props.purchaseData?.amountSpent || 0,
                amountObtained: props.purchaseData?.amountObtained || 0,
                usdCurrencyRate: props.purchaseData?.usdCurrencyRate || 1,
                fromCurrencyRate: 1,
                toCurrencyRate: props.purchaseData?.toCurrencyRate || 1,
                notes: props.purchaseData?.notes ?? null,
                fromCountryId: props.purchaseData?.fromCountryId || 'US',
                toCountryId: props.purchaseData?.toCountryId || 'GH'
            },
            poolId: props.purchaseData?.poolId || "",
            actionButtonLabel: props.action,
            accessToken: '',
            tradeDate: props.purchaseData?.tradeDate ? new Date(props.purchaseData.tradeDate) : new Date(),
            settlementDate: props.purchaseData?.settlementDate ? new Date(props.purchaseData.settlementDate) : new Date(),
            selectedLiquidityPartner: null,
            liquidityPartners: [],
            payoutPartners: [],
            statusOptions: [],
            files: [],
            deleteList: [],
            loading: false,
            errors: null,
            fromCurrencySymbol: '',// this.getCurrencySymbol(props.purchaseData?.currencySpent || 'USD'),
            toCurrencySymbol: '',//this.getCurrencySymbol(props.purchaseData?.currencyObtained || 'GHS'),
            selectedPayoutPartners: this.getSelectedPayoutPartners(props.purchaseData)
        };
        this.state = this.initialState;
    }

    async componentDidMount() {
        this.initializeToken();
        this.fetchDropdownData();
    }

    componentDidUpdate(prevProps: PurchaseDetailsProps, prevState: PurchaseDetailsState) {
        if (this.props.purchaseData !== prevProps.purchaseData) {
            const { purchaseData } = this.props;
            this.setState({
                purchaseData: {
                    ...purchaseData,
                    currencySpent: purchaseData?.currencySpent || '',
                    currencyObtained: purchaseData?.currencyObtained || '',
                    fromCountryId: purchaseData?.fromCountryId,
                    toCountryId: purchaseData?.toCountryId
                },
                tradeDate: purchaseData?.tradeDate ? new Date(purchaseData.tradeDate) : new Date(),
                settlementDate: purchaseData?.settlementDate ? new Date(purchaseData.settlementDate) : new Date(),
                selectedLiquidityPartner: purchaseData?.liquidityPartnerId ? this.state.liquidityPartners.filter(
                    partner => partner.id === purchaseData.liquidityPartnerId?.toString()
                )[0]
                    : null,
                selectedPayoutPartners: this.getSelectedPayoutPartners(purchaseData)
            });
        };

        if (this.state.purchaseData.currencySpent !== prevState.purchaseData.currencySpent) {
            this.setState(prevState => ({
                fromCurrencySymbol: this.getFromCurrencySymbol(prevState.purchaseData.currencySpent).currencySymbol
            }));
        }

        if (this.state.purchaseData.currencyObtained !== prevState.purchaseData.currencyObtained) {
            this.setState(prevState => ({
                toCurrencySymbol: this.getToCurrencySymbol(prevState.purchaseData.currencyObtained).currencySymbol
            }));
        }
    }

    initializeToken = async () => {
        const token: any = await loadFromLocalStorage('accessToken');
        if (token) {
            this.setState({ accessToken: token.toString() });
        };
        this.fromCurrencies = await fetchSenderCountryList(token.toString());
        this.toCurrencies = await fetchRecipientCountryList(token.toString());

        const purchaseData: any = this.state.purchaseData || {};
        const currencySpent = purchaseData.currencySpent || '';
        const currencyObtained = purchaseData.currencyObtained || '';

        const fromCurrency = this.getFromCurrencySymbol(currencySpent);
        const toCurrency = this.getToCurrencySymbol(currencyObtained);

        this.setState({
            fromCurrencySymbol: fromCurrency.currencySymbol,
            fromCountryId: fromCurrency.countryId,
            toCurrencySymbol: toCurrency.currencySymbol,
            toCountryId: toCurrency.countryId
        });
    };

    getSelectedPayoutPartners(purchaseData: IFXPoolDetails | undefined, lstPayoutPartners: IDropdownOption[] | null = null): IDropdownOptionArray {
        let selectedPayoutPartners: IDropdownOptionArray = [];
        if (purchaseData?.designatedPayoutPartnerNames) {
            const payoutPartnerIds = purchaseData?.designatedPayoutPartnerIds?.split(',') || [];

            const allPartners = lstPayoutPartners ?
                lstPayoutPartners.filter(p => p.id !== 'all') : [];

            const hasAllPartners = allPartners.length > 0 &&
                payoutPartnerIds.length === allPartners.length &&
                allPartners.every(partner =>
                    payoutPartnerIds.includes(partner.id.toString())
                );

            if (hasAllPartners && lstPayoutPartners) {
                const allOption = lstPayoutPartners.find(p => p.id === 'all');
                if (allOption) {
                    selectedPayoutPartners = [allOption, ...allPartners];
                } else {
                    selectedPayoutPartners = allPartners;
                }
            } else {
                if (lstPayoutPartners) {
                    selectedPayoutPartners = lstPayoutPartners.filter(p =>
                        payoutPartnerIds.includes(p.id.toString())
                    );
                }
            }
        }
        return selectedPayoutPartners;
    }

    fetchDropdownData = async () => {
        try {
            const token = this.state.accessToken || await loadFromLocalStorage('accessToken');
            if (!token) return;

            const [liquidityResponse, payoutResponse, statusResponse] = await Promise.all([
                FxAllocationService.getLiquidityPartners(token, this.getRequestPayload()),
                FxAllocationService.getPayoutPartners(token, this.getRequestPayload()),
                FxAllocationService.getPoolStatusList(token)
            ]);

            let files: any[] = [];
            if (this.state.poolId) {
                const filesResponse = await FxAllocationService.getAttachmentListByPoolId(token, this.state.poolId);
                files = await filesResponse.json();
            }

            const liquidityData = await liquidityResponse.json();
            const payoutData = await payoutResponse.json();
            const statusData = await statusResponse.json();

            const liquidityPartners = (liquidityData?.liquidityPartnerList || []).map(
                (partner: any) => ({
                    id: partner.liquidityPartnerId,
                    name: partner.liquidityPartnerName
                })
            );

            const payoutPartners = [
                { id: 'all', name: 'ALL' },
                ...(payoutData?.payoutPartnerList || []).map(
                    (partner: any) => ({
                        id: partner.payoutPartnerId,
                        name: partner.payoutPartnerName
                    })
                )
            ];

            const statusOptions = (statusData || []).map(
                (status: any) => ({
                    id: status.pool_status_id.toString(),
                    name: status.pool_status
                })
            );

            this.setState({
                liquidityPartners,
                payoutPartners,
                statusOptions,
                files,
                loading: false
            }, () => {
                if (this.props.purchaseData?.liquidityPartnerId) {
                    this.setState({
                        selectedLiquidityPartner: liquidityPartners.filter(
                            (partner: IDropdownOption) => partner.id === this.props.purchaseData?.liquidityPartnerId?.toString()
                        )[0]
                    });
                }
                if (this.props.purchaseData?.designatedPayoutPartnerNames) {
                    this.setState({
                        selectedPayoutPartners: this.getSelectedPayoutPartners(this.props.purchaseData, payoutPartners)
                    });
                }
            });
        } catch (error) {
            console.error("Error fetching dropdown data:", error);
            this.setState({ loading: false });
            ShowAlert("Error", "Failed to load dropdown data", "error");
        }
    };

    getRequestPayload = () => {
        return {
            pageNumber: 1,
            recordPerPage: 100
        };
    };

    parseFormattedAmount = (formattedValue: string) => {
        // return formattedValue.replace(/,/g, '');
        return formattedValue;
    };

    formatAmount = (amount: number, bUseCeil = false) => {
        if (amount === null || amount === undefined) return '0.00';
        return parseFloat((bUseCeil ? Math.ceil(amount) : amount).toString()).toFixed(2);
    };

    handleChange = (field: keyof IFXPoolDetails, value: string | number) => {
        this.setState(prevState => ({
            purchaseData: {
                ...prevState.purchaseData,
                [field]: value === '' ? null : value
            }
        }));
    };

    handleCurrencyChange = (field: 'currencySpent' | 'currencyObtained', value: string) => {
        const symbolField = field === 'currencySpent' ? 'fromCurrencySymbol' : 'toCurrencySymbol';
        const symbol = field === 'currencySpent' ? this.getFromCurrencySymbol(value) : this.getToCurrencySymbol(value);
        const countryId = field === 'currencySpent' ? 'fromCountryId' : 'toCountryId';

        this.setState(prevState => ({
            purchaseData: {
                ...prevState.purchaseData,
                [field]: value,
                [symbolField]: symbol.currencySymbol,
                amountSpent: 0,
                amountObtained: 0,
                [countryId]: symbol.countryId,
            }
        }));
    };

    handleAmountChange = (field: 'amountSpent' | 'amountObtained', value: string) => {
        const numValue = parseFloat(value) || 0;
        const { purchaseData } = this.state;
        const currentValue = parseFloat(this.initialState.purchaseData[field]) || 0;
        const effectiveRemainingBalance = parseFloat(purchaseData.effectiveRemainingBalance) || 0;

        if ((numValue < currentValue) &&
            (effectiveRemainingBalance === 0 ||
                (field === 'amountObtained' && effectiveRemainingBalance < (currentValue - numValue)) ||
                (field === 'amountSpent' && (effectiveRemainingBalance / parseFloat(purchaseData.toCurrencyRate)) < (currentValue - numValue))
            )) {
            return;
        };

        this.handleChange(field, numValue);
        const { purchaseData: updatedData } = this.state;
        if (field === 'amountSpent' && updatedData.toCurrencyRate) {
            this.handleChange('amountObtained', (numValue * (updatedData.toCurrencyRate || 1)).toFixed(2));
        } else if (field === 'amountObtained' && updatedData.toCurrencyRate) {
            this.handleChange('amountSpent', (numValue / (updatedData.toCurrencyRate || 1)).toFixed(2));
        }
    };

    handleRateChange = (field: 'usdCurrencyRate' | 'toCurrencyRate', value: string) => {
        const numValue = parseFloat(value) || 0;
        this.handleChange(field, numValue);

        const { purchaseData } = this.state;
        if (field === 'toCurrencyRate' && purchaseData.amountSpent) {
            this.handleChange('amountObtained', (purchaseData.amountSpent || 0) * numValue);
        }
    };

    handleTradeDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ tradeDate: new Date(e.target.value) });
    };

    handleSettlementDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        this.setState({ settlementDate: new Date(e.target.value) });
    };

    // Validate all fields before submission
    validateFields = () => {
        let isValid = true;
        const errors: IErrors = {
            liquidityPartner: "",
            tradeDate: "",
            baseRate: "",
            sourceRate: "",
            targetRate: "",
            sourceCurrency: "",
            sourceAmount: "",
            targetCurrency: "",
            targetAmount: "",
            attachment: ""
        };

        if (!this.state.selectedLiquidityPartner) {
            errors.liquidityPartner = "Liquidity partner is required";
            isValid = false;
        }

        if (!this.state.purchaseData?.tradeDate) {
            errors.tradeDate = "Trade date is required";
            isValid = false;
        }

        if (!this.state.purchaseData?.usdCurrencyRate || isNaN(+this.state.purchaseData?.usdCurrencyRate) || +this.state.purchaseData?.usdCurrencyRate <= 0) {
            errors.baseRate = "Base rate is required";
            isValid = false;
        }
        if (!this.state.purchaseData?.fromCurrencyRate || isNaN(+this.state.purchaseData?.fromCurrencyRate) || +this.state.purchaseData?.fromCurrencyRate <= 0) {
            errors.sourceRate = "Source rate is required";
            isValid = false;
        }

        if (!this.state.purchaseData?.toCurrencyRate || isNaN(+this.state.purchaseData?.toCurrencyRate) || +this.state.purchaseData?.toCurrencyRate <= 0) {
            errors.targetRate = "Target rate is required";
            isValid = false;
        }

        if (!this.state.purchaseData?.currencySpent) {
            errors.sourceCurrency = "Source currency is required";
            isValid = false;
        }

        if (!this.state.purchaseData?.amountSpent || isNaN(+this.state.purchaseData?.amountSpent) || +this.state.purchaseData?.amountSpent <= 0) {
            errors.sourceAmount = "Amount spent is required";
            isValid = false;
        }

        if (!this.state.purchaseData?.currencyObtained) {
            errors.targetCurrency = "Amount obtained is required";
            isValid = false;
        }


        if (!this.state.purchaseData?.amountObtained || isNaN(+this.state.purchaseData?.amountObtained) || +this.state.purchaseData?.amountObtained <= 0) {
            errors.targetAmount = "Target amount is required";
            isValid = false;
        }

        if (!(this.state.files && this.state.files.length > 0)) {
            errors.attachment = "Proof of purchase is required";
            isValid = false;
        }

        this.setState({
            errors: errors
        })
        return isValid;
    };

    handleEdit = async () => {
        const { actionButtonLabel, purchaseData, tradeDate, settlementDate, selectedLiquidityPartner, selectedPayoutPartners, accessToken, files, deleteList } = this.state;
        const { onClose } = this.props;

        if (actionButtonLabel === Actions.View) {
            this.setState({
                actionButtonLabel: Actions.Edit,
                isEditing: true
            });
        } else {
            if (!this.validateFields()) {
                return;
            }
            try {
                const filteredPayoutPartners = selectedPayoutPartners.filter(partner => partner.id !== 'ALL');
                const payload = {
                    tradeDate: tradeDate.toISOString(),
                    settlementDate: settlementDate.toISOString(),
                    //settlementDate: new Date(settlementDate.getTime() + 86400000).toISOString(), // Adding 1 day for settlement
                    usdCurrencyRate: purchaseData?.usdCurrencyRate?.toString(),
                    toCurrencyRate: purchaseData?.toCurrencyRate?.toString(),
                    currencySpent: purchaseData?.currencySpent,
                    amountSpent: purchaseData?.amountSpent?.toString(),
                    currencyObtained: purchaseData?.currencyObtained,
                    amountObtained: purchaseData?.amountObtained?.toString(),
                    targetCountryCorridor: purchaseData?.targetCountryCorridor,
                    liquidityPartnerId: selectedLiquidityPartner?.id,
                    designatedPayoutPartnerId: filteredPayoutPartners.length > 0 ? filteredPayoutPartners.map(p => p.id).join(',') : null,
                    poolStatusId: purchaseData?.poolStatusId,
                    notes: purchaseData?.notes || null,
                    fromCountryId: purchaseData?.fromCountryId,
                    toCountryId: purchaseData?.toCountryId,

                    files: files.filter(file => file.isNew)
                        .map(file => ({
                            fileName: file.fileName,
                            fileType: file.fileType,
                            fileSize: file.fileSize,
                            fileContentBase64: file.base64 ? file.base64 ? file.base64.split(',')[1] : null : null,
                        })),
                    deleteFiles: deleteList ? deleteList : []
                };

                const response = actionButtonLabel === Actions.Edit
                    ? await FxAllocationService.updatePurchaseRecord(
                        accessToken,
                        payload,
                        purchaseData.poolId || ''
                    )
                    : await FxAllocationService.createPurchase(accessToken, payload);

                if (response.ok) {
                    ShowAlert("Success", `Purchase record ${actionButtonLabel === Actions.Edit ? 'updated' : 'added'} successfully!`, "success")
                        .then(() => {
                            this.props.refreshData();
                        });
                    onClose();
                } else {
                    ShowAlert("Failed", `Failed to upload Attachment!`, "Failed")
                        .then(() => {
                            this.props.refreshData();
                        });
                    onClose();
                }
            } catch (error) {
                ShowAlert("Error", `Failed to ${actionButtonLabel === Actions.Edit ? 'update' : 'add'} FX purchase data`, "error");
            }
        }
    };

    handleCancel = () => {
        this.props.onClose();
    };

    handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files) {
            const files = Array.from(event.target.files);

            const filePromises = files.map(file => {
                return new Promise<{
                    fileName: string;
                    fileURL: null;
                    fileType: string;
                    fileSize: number;
                    base64: string;
                    fileAttachmentId: null;
                    isNew: boolean;
                }>((resolve, reject) => {
                    const reader = new FileReader();

                    reader.onload = () => {
                        const base64 = reader.result as string;
                        resolve({
                            fileName: file.name,
                            fileType: file.type,
                            fileSize: file.size,
                            fileURL: null,
                            fileAttachmentId: null,
                            base64,
                            isNew: true,
                        });
                    };

                    reader.onerror = (error) => reject(error);
                    reader.readAsDataURL(file);
                });
            });

            Promise.all(filePromises).then(base64Files => {
                this.setState(prevState => ({
                    files: [...prevState.files, ...base64Files]
                }));
            });
        }
    };

    handleDownloadFile = async (urlResp: any, fileName: any) => {
        if (urlResp) {
            const response = await fetch(urlResp);
            const blob = await response.blob();
            // Create a download link
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName; // You can set a dynamic filename if needed
            document.body.appendChild(a);
            a.click();

            // Clean up
            window.URL.revokeObjectURL(url);
            a.remove();
        } else {
            throw new Error("File download response not OK");
        }
    }

    handleDeleteFile = (index: number) => {

        const allFiles = [...this.state.files];
        const [deletedFile] = allFiles.splice(index, 1);
        if (deletedFile.fileAttachmentId) {
            this.state.deleteList.push(deletedFile);
        }
        this.setState({ files: allFiles });
    }

    render() {
        const { open } = this.props;
        const {
            isEditing,
            purchaseData,
            actionButtonLabel,
            tradeDate,
            settlementDate,
            selectedLiquidityPartner,
            selectedPayoutPartners,
            liquidityPartners,
            payoutPartners,
            statusOptions,
            files,
            loading,
            fromCurrencySymbol,
            toCurrencySymbol,
            errors
        } = this.state;

        return (
            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        this.handleCancel();
                    }
                }}
                fullWidth
                maxWidth="md"
                TransitionComponent={Transition}
                className="fx-purchase-details-dialog"
            >
                <DialogTitle className="dialog-title">
                    <Typography variant="h5" component="div">
                        FX Purchase Details
                    </Typography>
                </DialogTitle>

                <DialogContent>
                    <FormGroup>
                        <Box className="form-container">
                            <fieldset className="fieldset-border" style={{ marginBottom: '35px' }}>
                                <FormLabel className="section-label">Purchase Information</FormLabel>
                                <Box display="flex" gap={2} mb={2}>
                                    <Box flex={1}>
                                        <FormControl fullWidth>
                                            <FormLabel className="input-field-label">Liquidity Partner <span className='required'>{isEditing ? "\u00A0*" : ""}</span></FormLabel>
                                            {isEditing ? (
                                                <Autocomplete
                                                    className={!selectedLiquidityPartner && errors?.liquidityPartner ? 'error' : ''}
                                                    options={liquidityPartners}
                                                    getOptionLabel={(option) => option.name}
                                                    value={selectedLiquidityPartner}
                                                    onChange={(_, newValue) => {
                                                        this.setState({ selectedLiquidityPartner: newValue });
                                                    }}
                                                    disabled={(purchaseData?.totalAllocatedAmount && purchaseData.totalAllocatedAmount !== "0.00")}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder="Select liquidity partner"
                                                        />
                                                    )}
                                                />
                                            ) : (
                                                <Typography variant="body1">
                                                    {selectedLiquidityPartner?.name || 'Not specified'}
                                                </Typography>
                                            )}
                                            {!selectedLiquidityPartner && errors?.liquidityPartner ? (<p className='error-msg-required'>{errors.liquidityPartner}</p>) : ('')}
                                        </FormControl>
                                    </Box>
                                    <Box flex={1}>
                                        <FormControl fullWidth>
                                            <FormLabel className="input-field-label">Status</FormLabel>
                                            {isEditing ? (
                                                <Select
                                                    value={getValidSelectValue(
                                                        purchaseData?.poolStatusId ? String(purchaseData.poolStatusId) : '',
                                                        statusOptions.map(s => s.id)
                                                    )}
                                                    onChange={(e) => this.handleChange('poolStatusId', e.target.value)}
                                                    disabled={purchaseData?.effectiveRemainingBalance && purchaseData.effectiveRemainingBalance === "0.00" || (purchaseData?.totalAllocatedAmount && purchaseData.totalAllocatedAmount !== "0.00")}
                                                >
                                                    {statusOptions.map(status => (
                                                        <MenuItem key={status.id} value={status.id}>
                                                            {status.name}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            ) : (
                                                <Typography variant="body1">
                                                    {purchaseData?.poolStatus}
                                                </Typography>
                                            )}
                                        </FormControl>
                                    </Box>
                                </Box>
                                <Box display="flex" gap={2} mb={2}>
                                    <Box flex={1}>
                                        <FormControl fullWidth>
                                            <FormLabel className="input-field-label">Trade Date <span className='required'>{isEditing ? "\u00A0*" : ""}</span></FormLabel>
                                            {isEditing ? (
                                                <input
                                                    type="datetime-local"
                                                    className={!purchaseData?.tradeDate && errors?.tradeDate ? 'error' : ''}
                                                    value={moment(tradeDate).format('YYYY-MM-DDTHH:mm')}
                                                    onChange={this.handleTradeDateChange}
                                                    required
                                                    style={{
                                                        width: '100%',
                                                        padding: '8px',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px',
                                                        height: '56px',
                                                        fontFamily: 'inherit',
                                                        fontSize: '1rem'
                                                    }}
                                                />
                                            ) : (
                                                <Typography variant="body1">
                                                    {purchaseData ? moment(purchaseData.tradeDate).format(Texts.formatDateTimeDisplay) : ''}
                                                </Typography>
                                            )}
                                            {errors?.tradeDate ? (<p className='error-msg-required'>{errors.tradeDate}</p>) : ('')}
                                        </FormControl>
                                    </Box>
                                    <Box flex={1}>
                                        <FormControl fullWidth>
                                            <FormLabel className="input-field-label">Settlement Date</FormLabel>
                                            {isEditing ? (
                                                <input
                                                    type="datetime-local"
                                                    value={moment(settlementDate).format('YYYY-MM-DDTHH:mm')}
                                                    onChange={this.handleSettlementDateChange}
                                                    style={{
                                                        width: '100%',
                                                        padding: '8px',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px',
                                                        height: '56px',
                                                        fontFamily: 'inherit',
                                                        fontSize: '1rem'
                                                    }}
                                                />
                                            ) : (
                                                <Typography variant="body1">
                                                    {purchaseData ? moment(purchaseData.settlementDate).format(Texts.formatDateTimeDisplay) : ''}
                                                </Typography>
                                            )}
                                        </FormControl>
                                    </Box>
                                </Box>
                            </fieldset>

                            {/* Rest of your component remains the same */}
                            <fieldset className="fieldset-border" style={{ marginBottom: '35px' }}>
                                <FormLabel className="section-label">Transaction Details</FormLabel>
                                <Box style={{ display: 'none' }} display="grid" gridTemplateColumns="repeat(3, 1fr)" gap={2} mb={2}>
                                    <Box>
                                        <FormControl fullWidth>
                                            <FormLabel className="input-field-label">Source Rate <span className='required'>{isEditing ? "\u00A0*" : ""}</span></FormLabel>
                                            {isEditing ? (
                                                <InputTextField
                                                    value="1.00"
                                                    startAdornment={fromCurrencySymbol}
                                                    inputType="text"
                                                    disabled
                                                    onChange={() => { }}
                                                    error={!purchaseData?.fromCurrencyRate && errors?.sourceRate ? true : false}
                                                />
                                            ) : (
                                                <Typography variant="body1">
                                                    {purchaseData?.fromCurrencyRate}
                                                </Typography>
                                            )}
                                            {!purchaseData?.fromCurrencyRate && errors?.sourceRate ? (<p className='error-msg-required'>{errors.sourceRate}</p>) : ('')}
                                        </FormControl>
                                    </Box>
                                </Box>
                                <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap={2} mb={2}>
                                    <Box>
                                        <FormControl fullWidth>
                                            <FormLabel className="input-field-label">Source Currency <span className='required'>{isEditing ? "\u00A0*" : ""}</span></FormLabel>
                                            {isEditing ? (
                                                <Select
                                                    value={getValidSelectValue(
                                                        purchaseData?.currencySpent || '',
                                                        this.fromCurrencies.map((c: { currencyCode: any; }) => c.currencyCode)
                                                    )}
                                                    placeholder='Select source currency'
                                                    onChange={(e) => {this.handleCurrencyChange('currencySpent', e.target.value)}   }
                                                    fullWidth
                                                    disabled={(purchaseData?.totalAllocatedAmount && purchaseData.totalAllocatedAmount !== "0.00")}
                                                    className={!purchaseData?.currencySpent && errors?.sourceCurrency ? 'error' : ''}
                                                >
                                                    {this.fromCurrencies.map((currency: { currencyCode: string | number | readonly string[] | undefined; currencySymbol: any; countryName: any; }) => (
                                                        <MenuItem
                                                            key={`currency-${currency.currencyCode}`}
                                                            value={currency.currencyCode}
                                                        >
                                                            {`${currency.currencyCode} (${currency.currencySymbol}) - ${currency.countryName}`}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            ) : (
                                                <Typography variant="body1">
                                                    {purchaseData?.currencySpent || 'Not specified'}
                                                </Typography>
                                            )}
                                            {!purchaseData?.currencySpent && errors?.sourceCurrency ? (<p className='error-msg-required'>{errors.sourceCurrency}</p>) : ('')}
                                        </FormControl>
                                    </Box>
                                    <Box>
                                        <FormControl fullWidth>
                                            <FormLabel className="input-field-label">Base Rate (USD) <span className='required'>{isEditing ? "\u00A0*" : ""}</span></FormLabel>
                                            {isEditing ? (
                                                <InputTextField
                                                    value={this.formatAmount(purchaseData?.usdCurrencyRate || 1.00)}
                                                    startAdornment="$"
                                                    inputType="number"
                                                    onChange={(val) => this.handleRateChange('usdCurrencyRate', val)}
                                                    error={!purchaseData?.usdCurrencyRate && errors?.baseRate ? true : false}
                                                    disabled={(purchaseData?.totalAllocatedAmount && purchaseData.totalAllocatedAmount !== "0.00")}
                                                />
                                            ) : (
                                                <Typography variant="body1">
                                                    {"$"}&nbsp;{purchaseData?.usdCurrencyRate}
                                                </Typography>
                                            )}
                                            {!purchaseData?.usdCurrencyRate && errors?.baseRate ? (<p className='error-msg-required'>{errors.baseRate}</p>) : ('')}
                                            {isEditing ? (<p className="info">Example: 1{purchaseData?.currencySpent}=?USD</p>) : ('')}
                                        </FormControl>
                                    </Box>
                                    <Box>
                                        <FormControl fullWidth>
                                            <FormLabel className="input-field-label">Amount Spent  <span className='required'>{isEditing ? "\u00A0*" : ""}</span></FormLabel>
                                            {isEditing ? (
                                                <InputTextField
                                                    value={this.formatAmount(purchaseData?.amountSpent)}
                                                    startAdornment={fromCurrencySymbol}
                                                    inputType="number"
                                                    onChange={(val) => this.handleAmountChange('amountSpent', val)}
                                                    error={!purchaseData?.amountSpent && errors?.sourceAmount ? true : false}
                                                />
                                            ) : (
                                                <Typography variant="body1">
                                                    {fromCurrencySymbol}&nbsp;{purchaseData?.amountSpent?.toLocaleString()}
                                                </Typography>
                                            )}
                                            {!purchaseData?.amountSpent && errors?.sourceAmount ? (<p className='error-msg-required'>{errors.sourceAmount}</p>) : ('')}
                                        </FormControl>
                                    </Box>
                                </Box>
                                <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap={2}>
                                    <Box>
                                        <FormControl fullWidth>
                                            <FormLabel className="input-field-label">Target Currency <span className='required'>{isEditing ? "\u00A0*" : ""}</span></FormLabel>
                                            {isEditing ? (
                                                <Select
                                                    value={getValidSelectValue(
                                                        purchaseData?.currencyObtained || '',
                                                        this.toCurrencies.map((c: { currencyCode: any; }) => c.currencyCode)
                                                    )}
                                                    placeholder='Select target currency'
                                                    onChange={(e) => {
                                                        const selectedCurrency = e.target.value;
                                                        this.handleCurrencyChange('currencyObtained', e.target.value)
                                                        const matchedCountry = this.toCurrencies.find(
                                                            (currency: { currencyCode: string }) => currency.currencyCode === selectedCurrency
                                                        );
                                                    }}
                                                    fullWidth
                                                    className={!purchaseData?.currencyObtained && errors?.targetCurrency ? 'error' : ''}
                                                    disabled={(purchaseData?.totalAllocatedAmount && purchaseData.totalAllocatedAmount !== "0.00")}
                                                >
                                                    {this.toCurrencies.map((currency: { currencyCode: string | number | readonly string[] | undefined; currencySymbol: any; countryName: any;}) => (
                                                        <MenuItem
                                                            key={`currency-${currency.currencyCode}`}
                                                            value={currency.currencyCode}
                                                        >
                                                            {`${currency.currencyCode} (${currency.currencySymbol}) - ${currency.countryName}`}
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            ) : (
                                                <Typography variant="body1">
                                                    {purchaseData?.currencyObtained || 'Not specified'}
                                                </Typography>
                                            )}
                                            {!purchaseData?.currencyObtained && errors?.targetCurrency ? (<p className='error-msg-required'>{errors.targetCurrency}</p>) : ('')}
                                        </FormControl>
                                    </Box>
                                    <Box>
                                        <FormControl fullWidth>
                                            <FormLabel className="input-field-label">Exchange Rate <span className='required'>{isEditing ? "\u00A0*" : ""}</span></FormLabel>
                                            {isEditing ? (
                                                <InputTextField
                                                    value={this.formatAmount(purchaseData?.toCurrencyRate || 1.00)}
                                                    startAdornment={toCurrencySymbol}
                                                    inputType="number"
                                                    onChange={(val) => this.handleRateChange('toCurrencyRate', val)}
                                                    error={!purchaseData?.toCurrencyRate && errors?.targetRate ? true : false}
                                                    disabled={(purchaseData?.totalAllocatedAmount && purchaseData.totalAllocatedAmount !== "0.00")}
                                                />
                                            ) : (
                                                <Typography variant="body1">
                                                    {toCurrencySymbol}&nbsp;{purchaseData?.toCurrencyRate}
                                                </Typography>
                                            )}
                                            {!purchaseData?.toCurrencyRate && errors?.targetRate ? (<p className='error-msg-required'>{errors.targetRate}</p>) : ('')}
                                            {isEditing ? (<p className="info">Example: 1{purchaseData?.currencySpent}=?{purchaseData?.currencyObtained}</p>) : ('')}
                                        </FormControl>
                                    </Box>
                                    <Box>
                                        <FormControl fullWidth>
                                            <FormLabel className="input-field-label">Amount Obtained <span className='required'>{isEditing ? "\u00A0*" : ""}</span></FormLabel>
                                            {isEditing ? (
                                                <InputTextField
                                                    value={this.formatAmount(purchaseData?.amountObtained)}
                                                    startAdornment={toCurrencySymbol}
                                                    inputType="number"
                                                    onChange={(val) => this.handleAmountChange('amountObtained', val)}
                                                    error={!purchaseData?.amountObtained && errors?.targetAmount ? true : false}
                                                />
                                            ) : (
                                                <Typography variant="body1">
                                                    {toCurrencySymbol}&nbsp;{purchaseData?.amountObtained?.toLocaleString()}
                                                </Typography>
                                            )}
                                            {!purchaseData?.amountObtained && errors?.targetAmount ? (<p className='error-msg-required'>{errors.targetAmount}</p>) : ('')}
                                        </FormControl>
                                    </Box>
                                </Box>
                            </fieldset>

                            <fieldset className="fieldset-border" style={{ marginBottom: '35px' }}>
                                <FormLabel className="section-label">Allocation Details</FormLabel>
                                <Box display="flex" gap={2} mb={2}>
                                    <Box flex={1}>
                                        <FormControl fullWidth>
                                            <FormLabel className="input-field-label">Target Country Corridor </FormLabel>
                                            {/* {isEditing ? (
                                               )} */}
                                            {isEditing ? (
                                                <Autocomplete
                                                    options={this.toCurrencies.filter(
                                                        (currency: { currencyCode: string }) =>
                                                            currency.currencyCode === purchaseData?.currencyObtained
                                                    )}
                                                    getOptionLabel={(option) => option.countryId}
                                                    value={this.toCurrencies.find((currency: { countryId: any; }) =>
                                                        currency.countryId === purchaseData?.targetCountryCorridor
                                                    ) || null}
                                                    onChange={(_, newValue) => {
                                                        this.handleChange('targetCountryCorridor', newValue?.countryId || '');
                                                    }}
                                                    disabled={(purchaseData?.totalAllocatedAmount && purchaseData.totalAllocatedAmount !== "0.00")}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder="Select target country corridor"
                                                        />
                                                    )}
                                                />
                                            ) : (
                                                <Typography variant="body1">
                                                    {purchaseData?.targetCountryCorridor || 'Not specified'}
                                                </Typography>
                                            )}
                                        </FormControl>
                                    </Box>
                                    <Box flex={1}>
                                        <FormControl fullWidth>
                                            <FormLabel className="input-field-label">Payout Partner</FormLabel>
                                            {isEditing ? (
                                                <Autocomplete
                                                    multiple
                                                    options={payoutPartners}
                                                    getOptionLabel={(option) => option.name}
                                                    value={selectedPayoutPartners}
                                                    onChange={(_, newValue) => {
                                                        let selectedItems = newValue.map((item) => item.id);
                                                        if (selectedItems.includes("all") && !selectedPayoutPartners.some(p => p.id === "all")) {
                                                            newValue = payoutPartners;
                                                        } else if (!selectedItems.includes("all") && selectedPayoutPartners.some(p => p.id === "all")) {
                                                            selectedItems = [];
                                                            newValue = [];
                                                        } else if (selectedItems.includes("all") && newValue.length !== payoutPartners.length) {
                                                            newValue = newValue.filter(item => item.id !== "all");
                                                        } else if (!selectedItems.includes("all") && newValue.length === payoutPartners.length - 1) {
                                                            newValue = payoutPartners;
                                                        }
                                                        this.setState({ selectedPayoutPartners: newValue });
                                                    }}
                                                    disabled={(purchaseData?.totalAllocatedAmount && purchaseData.totalAllocatedAmount !== "0.00")}
                                                    disableCloseOnSelect
                                                    renderTags={(tagValue, getTagProps) => {
                                                        const visibleTags = tagValue.slice(0, 3).filter(tag => tag.id !== "all");
                                                        const allSelectedCount = tagValue.some(tag => tag.id === "all") ? 1 : 0;
                                                        const remainingCount = tagValue.length - visibleTags.length - allSelectedCount;
                                                        return (
                                                            <>
                                                                {visibleTags.map((option, index) => (
                                                                    <Chip
                                                                        label={option.name}
                                                                        {...getTagProps({ index })}
                                                                        key={option.id}
                                                                    />
                                                                ))}
                                                                {remainingCount > 0 && <Chip label={`+${remainingCount} more`} />}
                                                            </>
                                                        );
                                                    }}
                                                    limitTags={2}
                                                    openOnFocus
                                                    selectOnFocus
                                                    renderOption={(props, option, { selected }) => (
                                                        <li {...props}>
                                                            <Checkbox
                                                                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                                                                checkedIcon={<CheckBoxIcon fontSize="small" />}
                                                                style={{ marginRight: 5 }}
                                                                checked={selected}
                                                                color="secondary"
                                                            />
                                                            {option.name}
                                                        </li>
                                                    )}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder="Select payout partners"
                                                        />
                                                    )}
                                                />
                                            ) : (
                                                <Typography variant="body1">
                                                    {selectedPayoutPartners
                                                        .filter(p => p.id !== 'all')
                                                        .map(p => p.name)
                                                        .join(', ') || 'Not specified'
                                                    }
                                                </Typography>
                                            )}
                                        </FormControl>
                                    </Box>
                                </Box>
                            </fieldset>

                            {!isEditing && (
                                <fieldset className="fieldset-border" style={{ marginBottom: '35px' }}>

                                    <FormLabel className="section-label">Allocation Amount Details</FormLabel>
                                    <Box display="flex" gap={2} mb={2}>
                                        <Box flex={1}>
                                            <FormControl fullWidth>
                                                <FormLabel className="input-field-label">Total Allocated Amount</FormLabel>
                                                {isEditing ? (
                                                    <InputTextField
                                                        value={this.formatAmount(purchaseData?.totalAllocatedAmount)}
                                                        startAdornment={toCurrencySymbol}
                                                        inputType="text"
                                                        onChange={(val) => this.handleChange('totalAllocatedAmount', val)}
                                                        disabled={!isEditing || actionButtonLabel === Actions.Create}
                                                    />
                                                ) : (
                                                    <Typography variant="body1">
                                                        {toCurrencySymbol}&nbsp;{purchaseData?.totalAllocatedAmount?.toString() || 'Not specified'}
                                                    </Typography>
                                                )}
                                            </FormControl>
                                        </Box>
                                        <Box flex={1}>
                                            <FormControl fullWidth>
                                                <FormLabel className="input-field-label">Total Reversed Amount</FormLabel>
                                                {isEditing ? (
                                                    <InputTextField
                                                        value={this.formatAmount(purchaseData?.totalReversedAmount)}
                                                        startAdornment={toCurrencySymbol}
                                                        inputType="text"
                                                        onChange={(val) => this.handleChange('totalReversedAmount', val)}
                                                        disabled={!isEditing || actionButtonLabel === Actions.Create}
                                                    />
                                                ) : (
                                                    <Typography variant="body1">
                                                        {toCurrencySymbol}&nbsp;{purchaseData?.totalReversedAmount?.toString() || 'Not specified'}
                                                    </Typography>
                                                )}
                                            </FormControl>
                                        </Box>
                                        <Box flex={1}>
                                            <FormControl fullWidth>
                                                <FormLabel className="input-field-label">Effective Remaining Balance</FormLabel>
                                                {isEditing ? (
                                                    <InputTextField
                                                        value={this.formatAmount(actionButtonLabel === Actions.Create ? purchaseData?.amountObtained : (purchaseData?.effectiveRemainingBalance), actionButtonLabel === Actions.Create)}
                                                        startAdornment={toCurrencySymbol}
                                                        inputType="text"
                                                        onChange={(val) => this.handleChange('effectiveRemainingBalance', this.parseFormattedAmount(val))}
                                                        disabled={!isEditing || actionButtonLabel === Actions.Create}
                                                    />
                                                ) : (
                                                    <Typography variant="body1">
                                                        {toCurrencySymbol}&nbsp;{purchaseData?.effectiveRemainingBalance?.toString() || 'Not specified'}
                                                    </Typography>
                                                )}
                                            </FormControl>
                                        </Box>
                                    </Box>
                                </fieldset>
                            )}

                            <fieldset className="fieldset-border" style={{ marginBottom: '35px' }}>
                                <FormLabel className="input-field-label" style={{ marginTop: "0px" }}>Proof of purchase <span className='required'>{isEditing ? "\u00A0*" : ""}</span></FormLabel>
                                {isEditing && (
                                    <Box display="flex" gap={2} mb={2}>
                                        <Box flex={1}>
                                            <FormControl fullWidth>
                                                <Button
                                                    component="label"
                                                    color="secondary"
                                                    variant="contained"
                                                    tabIndex={-1}
                                                    startIcon={<CloudUploadIcon />}
                                                >
                                                    Select Files
                                                    <input
                                                        type="file"
                                                        multiple
                                                        style={{ display: 'none' }}
                                                        onChange={this.handleFileChange}
                                                    />
                                                </Button>
                                            </FormControl>
                                        </Box>
                                    </Box>
                                )}
                                {files.length === 0 && errors?.attachment ? (<p className='error-msg-required'>{errors?.attachment}</p>) : ('')}

                                {files.length > 0 && (
                                    <Box mt={2}>
                                        <List dense>
                                            {files.map((file, idx) => (
                                                <ListItem key={idx}
                                                    secondaryAction={isEditing && (
                                                        <IconButton edge="end" aria-label="delete" color="error" onClick={() => this.handleDeleteFile(idx)}>
                                                            <Delete />
                                                        </IconButton>
                                                    )}>
                                                    <ListItemText
                                                        primary={
                                                            file.fileURL ? (
                                                                <Button
                                                                    onClick={() => this.handleDownloadFile(file.fileURL, file.fileName)}
                                                                    sx={{ textTransform: 'none', padding: 0, minWidth: 0, color: '#1976d2' }}
                                                                >
                                                                    {file.fileName}
                                                                </Button>
                                                            ) : (
                                                                file.fileName
                                                            )
                                                        }
                                                        secondary={
                                                            file.fileSize
                                                                ? `${(file.fileSize / 1024).toFixed(2)} KB` : null
                                                        }
                                                    />
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Box>
                                )}
                            </fieldset>

                            <fieldset className="fieldset-border" style={{ marginBottom: '35px' }}>
                                <FormLabel className="input-field-label" style={{ marginTop: "0px" }}>Notes</FormLabel>
                                {isEditing ? (
                                    <Box display="flex" gap={2} mb={2}>
                                        <Box flex={1}>
                                            <FormControl fullWidth>
                                                <TextField
                                                    multiline
                                                    minRows={3}
                                                    value={purchaseData?.notes || ''}
                                                    onChange={(e) => this.handleChange('notes', e.target.value)}
                                                    variant="outlined"
                                                    fullWidth
                                                    placeholder="Notes (if any):"
                                                    inputProps={{ maxLength: 500 }}
                                                />
                                            </FormControl>
                                        </Box>
                                    </Box>
                                ) : (
                                    <Typography variant="body1">
                                        {purchaseData?.notes || 'Not specified'}
                                    </Typography>
                                )}
                            </fieldset>
                        </Box>
                    </FormGroup>
                </DialogContent>

                <DialogActions>
                    {actionButtonLabel !== Actions.View && (
                        <Button onClick={this.handleCancel}>
                            Cancel
                        </Button>

                    )}
                    {actionButtonLabel === Actions.View && (
                        <Button onClick={this.handleCancel}>
                            Cancel
                        </Button>

                    )}
                    {actionButtonLabel === Actions.View && (

                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={() => {
                                this.setState({
                                    actionButtonLabel: Actions.Edit,
                                    isEditing: true
                                });
                            }}
                        >
                            EDIT
                        </Button>
                    )}
                    {actionButtonLabel === Actions.Edit && (

                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={this.handleEdit}
                        >
                            UPDATE
                        </Button>
                    )}
                    {actionButtonLabel === Actions.Create && (
                        <Button
                            color="secondary"
                            variant="contained"
                            onClick={this.handleEdit}
                        >
                            ADD
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        );
    }
}

export default PurchaseDetails;